"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.textSizes = exports.sizeConstraints = exports.containerSizes = void 0;

var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/exports/StyleSheet"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// external imports
// local imports
var containerSizes = _StyleSheet.default.create({
  small: {
    height: 7 * _styles.baseDim
  },
  medium: {
    height: 10 * _styles.baseDim
  },
  large: {
    height: 14 * _styles.baseDim
  }
});

exports.containerSizes = containerSizes;

var sizeConstraints = _StyleSheet.default.create({
  small: {
    minWidth: 100,
    maxWidth: 210
  },
  medium: {
    minWidth: 120,
    maxWidth: 240
  },
  large: {
    minWidth: 150,
    maxWidth: 260
  }
});

exports.sizeConstraints = sizeConstraints;

var textSizes = _StyleSheet.default.create({
  small: {
    fontSize: 14
  },
  medium: {
    fontSize: 16
  },
  large: {
    fontSize: 18
  }
});

exports.textSizes = textSizes;

var styles = _StyleSheet.default.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    overflow: 'hidden'
  },
  disabled: {
    cursor: 'default'
  }
});

exports.styles = styles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/buttons/styles.js
// module id = ./node_modules/quark-core/components/buttons/styles.js
// module chunks = 0